/** "Link To This List": the share URL and an iframe embed snippet. */
export function LinkView({ url, onClose }: { url: string; onClose: () => void }) {
  return (
    <div className="LinkView shown" onClick={onClose}>
      <div className="model" onClick={(e) => e.stopPropagation()}>
        <div className="heading">
          Link To This List
          <img src="/assets/ui/close_x.png" alt="Close" onClick={onClose} />
        </div>
        <div className="content">
          <div className="innerContent">
            <span>Email, text, sharing (probably what you want):</span>
            <input aria-label="Share link" type="text" readOnly value={url} onFocus={(e) => e.currentTarget.select()} />
            <span>embed:</span>
            <textarea aria-label="Embed code" className="embedInput" readOnly value={`<iframe src="${url}"></iframe>`} onFocus={(e) => e.currentTarget.select()} />
          </div>
        </div>
      </div>
      <div className="triangle-down" />
    </div>
  );
}
